<template>
    <div>
        <v-layout row wrap>
            <v-flex xs12>
                <h4>{{ title }}</h4>
            </v-flex>
            <v-flex xs12 md4 px-3 py-0>
                <v-text-field
                    v-model="applicant.firstName"
                    :disabled="!canEdit"
                    label="First Name"
                    persistent-hint
                    type="input"
                    required
                    :rules="requiredRule"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md3 px-3 py-0>
                <v-text-field
                    v-model="applicant.middleName"
                    :disabled="!canEdit"
                    label="Middle Name"
                    persistent-hint
                    type="input"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md5 px-3 py-0>
                <v-text-field
                    v-model="applicant.lastName"
                    :disabled="!canEdit"
                    label="Last Name"
                    persistent-hint
                    type="input"
                    required
                    :rules="requiredRule"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md3 px-3 py-0>
                <v-text-field
                    v-model="applicant.priorLastName"
                    :disabled="!canEdit"
                    hint="Last name prior to 1st marriage"
                    label="Last name prior to 1st marriage"
                    persistent-hint
                    type="input"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md2 px-3 py-0>
                <v-select
                    v-model="applicant.suffix"
                    :disabled="!canEdit"
                    label="Suffix"
                    persistent-hint
                    :items="suffixList"
                    item-text="description"
                    item-value="id"
                ></v-select>
            </v-flex>
            <v-flex xs12 md3 px-3 py-0>
                <v-select
                    v-model="applicant.sex"
                    :disabled="!canEdit"
                    label="Sex"
                    persistent-hint
                    :items="sexList"
                    item-text="description"
                    item-value="id"
                    required
                    :rules="requiredRule"
                ></v-select>
            </v-flex>
            <v-flex xs12 md4 px-3 py-0>
                <v-text-field
                    v-model="applicant.dateOfBirth"
                    :disabled="!canEdit"
                    label="Date of Birth"
                    persistent-hint
                    type="date"
                    required
                    :rules="requiredRule"
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12 md4 px-3>
                <v-text-field
                    v-model="applicant.ssn"
                    :disabled="!canEdit"
                    label="Social Security Number"
                    persistent-hint
                    type="text"
                    v-mask="'###-##-####'"
                    placeholder="###-##-####"
                    required
                    :rules="requiredRule"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 px-3>
                <v-checkbox
                    v-model="applicant.doesNotHaveSsn"
                    :disabled="!canEdit"
                    label="I do not have a SSN"
                ></v-checkbox>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs6 px-3 py-0>
                <v-select
                    v-model="applicant.placeOfBirthCountry"
                    :disabled="!canEdit"
                    label="Place of Birth"
                    hint="Country"
                    persistent-hint
                    :items="countryList"
                    item-text="description"
                    item-value="id"
                    required
                    :rules="requiredRule"
                ></v-select>
            </v-flex>
            <v-flex xs6 px-3 py-0 v-show="isBirthCountryOther">
                <v-text-field
                    v-model="applicant.placeOfBirthCountryOther"
                    :disabled="!canEdit"
                    label="Other Country"
                    persistent-hint
                    type="input"
                    :required="isBirthCountryOther"
                    :rules="isBirthCountryOther ? requiredRule : []"
                ></v-text-field>
            </v-flex>
            <v-flex xs6 px-3 py-0 v-show="applicant.placeOfBirthCountry">
                <v-select
                    v-model="applicant.placeOfBirthState"
                    :disabled="!canEdit"
                    label="Place of Birth"
                    hint="State"
                    persistent-hint
                    :items="stateList"
                    item-text="description"
                    item-value="id"
                    required
                    :rules="requiredRule"
                ></v-select>
            </v-flex>
            <v-flex xs6 px-3 py-0 v-show="isBirthStateOther">
                <v-text-field
                    v-model="applicant.placeOfBirthStateOther"
                    :disabled="!canEdit"
                    label="Other State"
                    persistent-hint
                    type="input"
                    :required="isBirthStateOther"
                    :rules="isBirthStateOther ? requiredRule : []"
                ></v-text-field>
            </v-flex>
        </v-layout>
        <br />
        <v-layout row wrap>
            <v-flex xs12 md8 px-3 py-0>
                <v-text-field
                    v-model="applicant.email"
                    :disabled="!canEdit"
                    label="Email Address"
                    persistent-hint
                    type="input"
                    required
                    :rules="requiredRule"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 px-3 py-0>
                <v-text-field
                    v-model="applicant.phone"
                    :disabled="!canEdit"
                    label="Phone Number"
                    persistent-hint
                    type="text"
                    v-mask="'(###)-###-####'"
                    placeholder="(XXX)-XXX-XXXX"
                    :rules="requiredRule"
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12>
                <addr
                    ref="applicantResidentialRef"
                    id="applicantResidential"
                    :isRequired="isRequired"
                    :disabled="!canEdit"
                    customAddressLabelPrepend="Residential "
                    :componentId="applicantNum + '1'"
                ></addr>
            </v-flex>
            <v-flex xs12 px-3>
                <v-checkbox
                    v-model="applicant.diffMailingThanResidential"
                    :disabled="!canEdit"
                    label="Mailing Address is different than Residential."
                ></v-checkbox>
            </v-flex>
            <v-flex xs12 v-show="IsMailingDiff">
                <addr
                    ref="applicantMailingRef"
                    id="applicantMailing"
                    :isRequired="IsMailingDiff"
                    :disabled="!canEdit"
                    customAddressLabelPrepend="Mailing "
                    :componentId="applicantNum + '2'"
                ></addr>
            </v-flex>
        </v-layout>
        <br /><br />
        <v-layout row wrap>
            <v-flex xs12 md5 px-3 py-0>
                <v-select
                    v-model="applicant.isFirstMarriage"
                    :disabled="!canEdit"
                    label="Is this your first marriage?"
                    persistent-hint
                    :items="yesNoList"
                    item-text="description"
                    item-value="id"
                    required
                    :rules="requiredRule"
                ></v-select>
            </v-flex>
            <v-flex xs12 md7 px-3 py-0 v-show="isNotFirstMarriage">
                <v-select
                    v-model="applicant.maritalStatus"
                    :disabled="!canEdit"
                    label="Current Marital Status"
                    persistent-hint
                    :items="maritalStatusList"
                    item-text="description"
                    item-value="id"
                ></v-select>
            </v-flex>
            <v-flex xs12 md4 px-3 py-0 v-show="isMaritalStatusDivorce">
                <v-text-field
                    v-model="applicant.divorceDate"
                    :disabled="!canEdit"
                    label="Divorce Date"
                    persistent-hint
                    type="date"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 px-3 py-0 v-show="isMaritalStatusDivorce">
                <v-select
                    v-model="applicant.divorceCountry"
                    :disabled="!canEdit"
                    label="Divorce Country"
                    persistent-hint
                    :items="countryList"
                    item-text="description"
                    item-value="id"
                ></v-select>
            </v-flex>
            <v-flex xs6 px-3 py-0 v-show="isDivorceCountryOther">
                <v-text-field
                    v-model="applicant.divorceCountryOther"
                    :disabled="!canEdit"
                    label="Other Country"
                    persistent-hint
                    type="input"
                    :required="isDivorceCountryOther"
                    :rules="isDivorceCountryOther ? requiredRule : []"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 px-3 py-0 v-show="applicant.divorceCountry">
                <v-select
                    v-model="applicant.divorceState"
                    :disabled="!canEdit"
                    label="Divorce State"
                    persistent-hint
                    :items="divorceStateList"
                    item-text="description"
                    item-value="id"
                ></v-select>
            </v-flex>
            <v-flex xs6 px-3 py-0 v-show="isDivorceStateOther">
                <v-text-field
                    v-model="applicant.divorceStateOther"
                    :disabled="!canEdit"
                    label="Other State"
                    persistent-hint
                    type="input"
                    :required="isDivorceStateOther"
                    :rules="isDivorceStateOther ? requiredRule : []"
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12 md4 px-3 py-0 v-show="isMaritalStatusWidowed">
                <v-text-field
                    v-model="applicant.widowedDate"
                    :disabled="!canEdit"
                    label="Widowed Date"
                    persistent-hint
                    type="date"
                ></v-text-field>
            </v-flex>
        </v-layout>
        <br /><br />
        <v-layout row wrap>
            <v-flex xs12 md6 px-3 py-0>
                <v-select
                    v-model="applicant.ethnicity"
                    :disabled="!canEdit"
                    label="Ethnicity"
                    persistent-hint
                    type="input"
                    :items="ethnicityList"
                    item-text="description"
                    item-value="id"
                    required
                    :rules="requiredRule"
                ></v-select>
            </v-flex>
            <v-flex xs12 md6 px-3 py-0 v-show="isEthnicityOther">
                <v-text-field
                    v-model="applicant.ethnicityOther"
                    :disabled="!canEdit"
                    label="Ethnicity Other"
                    persistent-hint
                    type="input"
                    :required="isEthnicityOther"
                    :rules="isEthnicityOther ? requiredRule : []"
                ></v-text-field>
            </v-flex>
        </v-layout>
        <br />
        <v-layout row wrap>
            <v-flex xs12 px-3 py-0>
                Race:
                <v-layout row wrap>
                    <v-flex xs12 sm6 md6 lg4 px-2>
                        <v-checkbox
                            v-model="applicant.raceList"
                            :disabled="!canEdit"
                            label="White"
                            :value="1"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 px-2>
                        <v-checkbox
                            v-model="applicant.raceList"
                            :disabled="!canEdit"
                            label="Black or African American"
                            :value="2"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 px-2>
                        <v-checkbox
                            v-model="applicant.raceList"
                            :disabled="!canEdit"
                            label="American Indian or Alaskan Native"
                            :value="3"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 px-2>
                        <v-checkbox
                            v-model="applicant.raceList"
                            :disabled="!canEdit"
                            label="Asian Indian"
                            :value="4"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 px-2>
                        <v-checkbox
                            v-model="applicant.raceList"
                            :disabled="!canEdit"
                            label="Chinese"
                            :value="5"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 px-2>
                        <v-checkbox
                            v-model="applicant.raceList"
                            :disabled="!canEdit"
                            label="Filipino"
                            :value="6"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 px-2>
                        <v-checkbox
                            v-model="applicant.raceList"
                            :disabled="!canEdit"
                            label="Japanese"
                            :value="7"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 px-2>
                        <v-checkbox
                            v-model="applicant.raceList"
                            :disabled="!canEdit"
                            label="Korean"
                            :value="8"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 px-2>
                        <v-checkbox
                            v-model="applicant.raceList"
                            :disabled="!canEdit"
                            label="Vietnamese"
                            :value="9"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 px-2>
                        <v-checkbox
                            v-model="applicant.raceList"
                            :disabled="!canEdit"
                            label="Other Asian"
                            :value="10"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 px-2>
                        <v-checkbox
                            v-model="applicant.raceList"
                            :disabled="!canEdit"
                            label="Native Hawaiian"
                            :value="11"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 px-2>
                        <v-checkbox
                            v-model="applicant.raceList"
                            :disabled="!canEdit"
                            label="Guamanian or Chamorro"
                            :value="12"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 px-2>
                        <v-checkbox
                            v-model="applicant.raceList"
                            :disabled="!canEdit"
                            label="Samoan"
                            :value="13"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 px-2>
                        <v-checkbox
                            v-model="applicant.raceList"
                            :disabled="!canEdit"
                            label="Other Pacific Islander"
                            :value="14"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 px-2>
                        <v-checkbox
                            v-model="applicant.raceList"
                            :disabled="!canEdit"
                            label="Other"
                            :value="15"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 px-2>
                        <v-checkbox
                            v-model="applicant.raceList"
                            :disabled="!canEdit"
                            label="Unknown"
                            :value="16"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 px-2>
                        <v-checkbox
                            v-model="applicant.raceList"
                            :disabled="!canEdit"
                            label="Refused"
                            :value="17"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 px-2>
                        <v-checkbox
                            v-model="applicant.raceList"
                            :disabled="!canEdit"
                            label="Not Obtainable"
                            :value="18"
                        ></v-checkbox>
                    </v-flex>
                </v-layout>
                <v-layout row wrap pt-0 mt-0>
                    <v-flex xs4 px-3 v-show="isRaceOther">
                        <v-text-field
                            v-model="applicant.raceOther"
                            :disabled="!canEdit"
                            label="Race Other"
                            persistent-hint
                            type="input"
                            hint="Race Other"
                            :required="isRaceOther"
                            :rules="isRaceOther ? requiredRule : []"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs4 px-3 v-show="IsRaceOtherAsian">
                        <v-text-field
                            v-model="applicant.raceOtherAsian"
                            :disabled="!canEdit"
                            label="Other Asian"
                            persistent-hint
                            type="input"
                            hint="Other Asian"
                            :required="IsRaceOtherAsian"
                            :rules="IsRaceOtherAsian ? requiredRule : []"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs4 px-3 v-show="IsRaceOtherPacificIslander">
                        <v-text-field
                            v-model="applicant.raceOtherPacificIslander"
                            :disabled="!canEdit"
                            label="Other Pacific Islander"
                            persistent-hint
                            type="input"
                            hint="Other Pacific Islander"
                            :required="IsRaceOtherPacificIslander"
                            :rules="IsRaceOtherPacificIslander ? requiredRule : []"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs4 px-3 v-show="IsRaceOtherAmericanIndian">
                        <v-text-field
                            v-model="applicant.raceOtherAmericanIndian"
                            :disabled="!canEdit"
                            label="Other American Indian or Alaskan Native"
                            persistent-hint
                            type="input"
                            hint="Other American Indian or Alaskan Native"
                            :required="IsRaceOtherAmericanIndian"
                            :rules="IsRaceOtherAmericanIndian ? requiredRule : []"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <br /><br />
        <v-layout row wrap>
            <v-flex xs12 px-3>
                <v-select
                    v-model="applicant.education"
                    :disabled="!canEdit"
                    label="Education"
                    persistent-hint
                    type="input"
                    :items="educationList"
                    item-text="description"
                    item-value="id"
                    required
                    :rules="requiredRule"
                ></v-select>
            </v-flex>
        </v-layout>
        <br /><br />
        <h5>{{ title }} - Mother/Parent:</h5>
        <v-layout row wrap>
            <v-flex xs12 md4 px-3 py-0>
                <v-text-field
                    v-model="applicant.motherFirstName"
                    :disabled="!canEdit"
                    label="First Name"
                    persistent-hint
                    type="input"
                    hint="Mother/Parent"
                    required
                    :rules="requiredRule"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 px-3 py-0>
                <v-text-field
                    v-model="applicant.motherMiddleName"
                    :disabled="!canEdit"
                    label="Middle Name"
                    persistent-hint
                    type="input"
                    hint="Mother/Parent"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 px-3 py-0>
                <v-text-field
                    v-model="applicant.motherLastName"
                    :disabled="!canEdit"
                    label="Last Name"
                    persistent-hint
                    type="input"
                    hint="Mother/Parent"
                    required
                    :rules="requiredRule"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 px-3 py-0>
                <v-text-field
                    v-model="applicant.motherPriorLastName"
                    :disabled="!canEdit"
                    label="Prior Last Name"
                    persistent-hint
                    type="input"
                    hint="Mother/Parent"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md2 px-3 py-0>
                <v-select
                    v-model="applicant.motherSuffix"
                    :disabled="!canEdit"
                    label="Suffix"
                    persistent-hint
                    :items="suffixList"
                    item-text="description"
                    item-value="id"
                ></v-select>
            </v-flex>
            <v-flex xs12 md3 px-3 py-0>
                <v-select
                    v-model="applicant.motherSex"
                    :disabled="!canEdit"
                    label="Sex"
                    persistent-hint
                    :items="sexList"
                    item-text="description"
                    item-value="id"
                    required
                    :rules="requiredRule"
                ></v-select>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12 md6 px-3 py-0>
                <v-select
                    v-model="applicant.motherBirthPlaceCountry"
                    :disabled="!canEdit"
                    label="Birth Country"
                    persistent-hint
                    type="input"
                    hint="Mother/Parent"
                    :items="countryList"
                    item-text="description"
                    item-value="id"
                    required
                    :rules="requiredRule"
                ></v-select>
            </v-flex>
            <v-flex xs6 px-3 py-0 v-show="isMomCountryOther">
                <v-text-field
                    v-model="applicant.motherBirthPlaceCountryOther"
                    :disabled="!canEdit"
                    label="Other Country"
                    persistent-hint
                    type="input"
                    :required="isMomCountryOther"
                    :rules="isMomCountryOther ? requiredRule : []"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 px-3 py-0 v-show="applicant.motherBirthPlaceCountry">
                <v-select
                    v-model="applicant.motherBirthPlaceState"
                    :disabled="!canEdit"
                    label="Birth State"
                    persistent-hint
                    type="input"
                    hint="Mother/Parent"
                    :items="momStateList"
                    item-text="description"
                    item-value="id"
                    required
                    :rules="requiredRule"
                ></v-select>
            </v-flex>
            <v-flex xs6 px-3 py-0 v-show="isMomStateOther">
                <v-text-field
                    v-model="applicant.motherBirthPlaceStateOther"
                    :disabled="!canEdit"
                    label="Other State"
                    persistent-hint
                    type="input"
                    :required="isMomStateOther"
                    :rules="isMomStateOther ? requiredRule : []"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 px-3>
                <v-checkbox
                    v-model="applicant.unknownMother"
                    :disabled="!canEdit"
                    label="Unknown Mother/Parent"
                ></v-checkbox>
            </v-flex>
        </v-layout>
        <br />
        <h5>{{ title }} - Father/Parent:</h5>
        <v-layout row wrap>
            <v-flex xs12 md4 px-3 py-0>
                <v-text-field
                    v-model="applicant.fatherFirstName"
                    :disabled="!canEdit"
                    label="First Name"
                    persistent-hint
                    type="input"
                    hint="Father/Parent"
                    required
                    :rules="requiredRule"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 px-3 py-0>
                <v-text-field
                    v-model="applicant.fatherMiddleName"
                    :disabled="!canEdit"
                    label="Middle Name"
                    persistent-hint
                    type="input"
                    hint="Father/Parent"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 px-3 py-0>
                <v-text-field
                    v-model="applicant.fatherLastName"
                    :disabled="!canEdit"
                    label="Last Name"
                    persistent-hint
                    type="input"
                    hint="Father/Parent"
                    required
                    :rules="requiredRule"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 px-3 py-0>
                <v-text-field
                    v-model="applicant.fatherPriorLastName"
                    :disabled="!canEdit"
                    label="Prior Last Name"
                    persistent-hint
                    type="input"
                    hint="Father/Parent"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md2 px-3 py-0>
                <v-select
                    v-model="applicant.fatherSuffix"
                    :disabled="!canEdit"
                    label="Suffix"
                    persistent-hint
                    :items="suffixList"
                    item-text="description"
                    item-value="id"
                ></v-select>
            </v-flex>
            <v-flex xs12 md3 px-3 py-0>
                <v-select
                    v-model="applicant.fatherSex"
                    :disabled="!canEdit"
                    label="Sex"
                    persistent-hint
                    :items="sexList"
                    item-text="description"
                    item-value="id"
                    required
                    :rules="requiredRule"
                ></v-select>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12 md6 px-3 py-0>
                <v-select
                    v-model="applicant.fatherBirthPlaceCountry"
                    :disabled="!canEdit"
                    label="Birth Country"
                    persistent-hint
                    type="input"
                    hint="Father/Parent"
                    :items="countryList"
                    item-text="description"
                    item-value="id"
                    required
                    :rules="requiredRule"
                ></v-select>
            </v-flex>
            <v-flex xs6 px-3 py-0 v-show="isDadCountryOther">
                <v-text-field
                    v-model="applicant.fatherBirthPlaceCountryOther"
                    :disabled="!canEdit"
                    label="Other Country"
                    persistent-hint
                    type="input"
                    :required="isDadCountryOther"
                    :rules="isDadCountryOther ? requiredRule : []"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 px-3 py-0 v-show="applicant.fatherBirthPlaceCountry">
                <v-select
                    v-model="applicant.fatherBirthPlaceState"
                    :disabled="!canEdit"
                    label="Birth State"
                    persistent-hint
                    type="input"
                    hint="Father/Parent"
                    :items="dadStateList"
                    item-text="description"
                    item-value="id"
                    required
                    :rules="requiredRule"
                ></v-select>
            </v-flex>
            <v-flex xs6 px-3 py-0 v-show="isDadStateOther">
                <v-text-field
                    v-model="applicant.fatherBirthPlaceStateOther"
                    :disabled="!canEdit"
                    label="Other State"
                    persistent-hint
                    type="input"
                    :required="isDadStateOther"
                    :rules="isDadStateOther ? requiredRule : []"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 px-3>
                <v-checkbox
                    v-model="applicant.unknownFather"
                    :disabled="!canEdit"
                    label="Unknown Father/Parent"
                ></v-checkbox>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import Addr from '@/components/Address'
import lookupService from '@/services/lookupService'
import marriageService from '@/services/marriageWorksheetService'

export default {
    name: 'marriage-ws-applicant',
    components: {
        Addr
    },
    directives: {
        mask
    },
    props: {
        isRequired: Boolean,
        canEdit: Boolean,
        title: String,
        applicantProp: {},
        applicantNum: Number
    },
    data: () => {
        return {
            stateList: [],
            sexList: [],
            suffixList: [],
            divorceStateList: [],
            educationList: [],
            momStateList: [],
            dadStateList: [],
            countryList: [],
            yesNoList: [],
            maritalStatusList: [],
            ethnicityList: [],
            applicant: {},
            maritalStatusEnum: marriageService.MaritalStatusEnum,
            stateListUS: [],
            stateListCanada: []
        }
    },
    mounted () {
        this.load()
    },
    computed: {
        requiredRule () {
            return [
                v => {
                    if (this.isRequired) return !!v || 'Required'
                    else return true
                }
            ]
        },
        isBirthCountryOther () {
            return this.applicant.placeOfBirthCountry == lookupService.CountryEnum.Other
        },
        isBirthStateOther () {
            return this.applicant.placeOfBirthState == lookupService.StateEnum.Other
        },
        isDivorceCountryOther () {
            return this.applicant.divorceCountry == lookupService.CountryEnum.Other
        },
        isDivorceStateOther () {
            return this.applicant.divorceState == lookupService.StateEnum.Other
        },
        isMomCountryOther () {
            return this.applicant.motherBirthPlaceCountry == lookupService.CountryEnum.Other
        },
        isMomStateOther () {
            return this.applicant.motherBirthPlaceState == lookupService.StateEnum.Other
        },
        isDadCountryOther () {
            return this.applicant.fatherBirthPlaceCountry == lookupService.CountryEnum.Other
        },
        isDadStateOther () {
            return this.applicant.fatherBirthPlaceState == lookupService.StateEnum.Other
        },
        isNotFirstMarriage () {
            return this.applicant.isFirstMarriage == 2
        },
        isMaritalStatusDivorce () {
            return this.applicant.maritalStatus && this.applicant.maritalStatus == this.maritalStatusEnum.Divorced
        },
        isMaritalStatusWidowed () {
            return this.applicant.maritalStatus == this.maritalStatusEnum.Widowed
        },
        isEthnicityOther () {
            return this.applicant.ethnicity == lookupService.HispanicOriginEnum.Other
        },
        isRaceOther () {
            return (this.applicant.raceList || []).includes(lookupService.RaceEnum.Other)
        },
        IsRaceOtherAsian () {
            return (this.applicant.raceList || []).includes(lookupService.RaceEnum.OtherAsian)
        },
        IsRaceOtherPacificIslander () {
            return (this.applicant.raceList || []).includes(lookupService.RaceEnum.OtherPacificIslander)
        },
        IsRaceOtherAmericanIndian () {
            return (this.applicant.raceList || []).includes(lookupService.RaceEnum.AmericanIndianOrAfricanAmerican)
        },
        IsMailingDiff () {
            return this.applicant.diffMailingThanResidential
        }
    },
    methods: {
        load () {
            lookupService.GetSexList(this.$http).then(response => {
                this.sexList = response.data
            })
            lookupService.GetMarriageMaritalStatusList(this.$http).then(response => {
                this.maritalStatusList = response.data.filter((item) => item.id !== marriageService.MaritalStatusEnum.Single)
            })
            lookupService.GetSuffixes(this.$http).then(response => {
                this.suffixList = response.data
            })
            lookupService.GetCountries(this.$http).then(response => {
                this.countryList = response.data
            })
            lookupService.GetHispanicOriginTypes(this.$http).then(response => {
                this.ethnicityList = response.data
            })
            lookupService.GetEducationTypes(this.$http).then(response => {
                this.educationList = response.data
            })
            this.yesNoList = lookupService.YesNoList
            lookupService.GetStatesByCountry(this.$http, lookupService.CountryEnum.UnitedStates).then(response => {
                this.stateListUS = response.data
            })
            lookupService.GetStatesByCountry(this.$http, lookupService.CountryEnum.Canada).then(response => {
                this.stateListCanada = response.data
            })
        },
        getApplicant () {
            this.applicant.residentialAddress = this.$refs.applicantResidentialRef.placeDTO
            if (this.applicant.diffMailingThanResidential) {
                this.applicant.mailingAddress = this.$refs.applicantMailingRef.placeDTO
            } else {
                this.applicant.mailingAddress = JSON.parse(JSON.stringify(this.$refs.applicantResidentialRef.placeDTO))
            }
            this.applicant.ssn = (this.applicant.ssn || '').replace(/\D/g, '')
            this.applicant.phone = (this.applicant.phone || '').replace(/\D/g, '')
            this.$emit('applicant', this.applicant, this.applicantNum - 1)
        },
        getStateListByCountryId (countryId) {
            if (countryId == lookupService.CountryEnum.UnitedStates) {
                return this.stateListUS
            } else if (countryId == lookupService.CountryEnum.Canada) {
                return this.stateListCanada
            } else {
                return lookupService.UnknownOtherStates
            }
        }
    },
    watch: {
        applicantProp: {
            handler (newVal, oldVal) {
                if (oldVal === null) return
                this.applicant = newVal
                if (!this.applicant.raceList) this.applicant.raceList = []
            }
        },
        'applicant.diffMailingThanResidential': {
            handler (newVal, oldVal) {
                if (oldVal === null) return

                if (newVal) {
                    this.$refs.applicantMailingRef.placeDTO = {}
                } else {
                    this.$refs.applicantMailingRef.placeDTO = JSON.parse(JSON.stringify(this.$refs.applicantResidentialRef.placeDTO))
                }
            }
        },
        'applicant.mailingAddress': {
            handler (newVal, oldVal) {
                if (oldVal === null) return

                if (newVal) {
                    this.$refs.applicantMailingRef.placeDTO = newVal
                }
            }
        },
        'applicant.residentialAddress': {
            handler (newVal, oldVal) {
                if (oldVal === null) return

                if (newVal) {
                    this.$refs.applicantResidentialRef.placeDTO = newVal
                }
            }
        },
        'applicant.placeOfBirthCountry': {
            handler (newVal, oldVal) {
                if (newVal) {
                    this.stateList = this.getStateListByCountryId(newVal)
                }
                if (oldVal === null) return
                if (newVal != lookupService.CountryEnum.Other) this.applicant.placeOfBirthCountryOther = null
                if (!this.stateList.find(x => x.id == this.applicant.placeOfBirthState)) {
                    this.applicant.placeOfBirthState = null
                }
            }
        },
        'applicant.placeOfBirthState': {
            handler (newVal, oldVal) {
                if (oldVal === null) return
                if (newVal != lookupService.StateEnum.Other) this.applicant.placeOfBirthStateOther = null
            }
        },
        'applicant.isFirstMarriage': {
            handler (newVal, oldVal) {
                if (oldVal === null) return
                if (newVal != 2) this.applicant.maritalStatus = null
            }
        },
        'applicant.maritalStatus': {
            handler (newVal, oldVal) {
                if (oldVal === null) return
                if (newVal != this.maritalStatusEnum.Divorced) {
                    this.applicant.divorceCountry = null
                    this.applicant.divorceDate = null
                }
                if (newVal != this.maritalStatusEnum.Widowed) {
                    this.applicant.widowedDate = null
                }
            }
        },
        'applicant.divorceCountry': {
            handler (newVal, oldVal) {
                if (newVal) {
                    this.divorceStateList = this.getStateListByCountryId(newVal)
                }
                if (oldVal === null) return
                if (newVal != lookupService.CountryEnum.Other) this.applicant.divorceCountryOther = null
                if (!this.divorceStateList.find(x => x.id == this.applicant.divorceState)) {
                    this.applicant.divorceState = null
                }
            }
        },
        'applicant.divorceState': {
            handler (newVal, oldVal) {
                if (oldVal === null) return
                if (newVal != lookupService.StateEnum.Other) this.applicant.divorceStateOther = null
            }
        },
        'applicant.motherBirthPlaceCountry': {
            handler (newVal, oldVal) {
                if (newVal) {
                    this.momStateList = this.getStateListByCountryId(newVal)
                }
                if (oldVal === null) return
                if (newVal != lookupService.CountryEnum.Other) this.applicant.motherBirthPlaceCountryOther = null
                if (!this.momStateList.find(x => x.id == this.applicant.motherBirthPlaceState)) {
                    this.applicant.motherBirthPlaceState = null
                }
            }
        },
        'applicant.motherBirthPlaceState': {
            handler (newVal, oldVal) {
                if (oldVal === null) return
                if (newVal != lookupService.StateEnum.Other) this.applicant.motherBirthPlaceStateOther = null
            }
        },
        'applicant.fatherBirthPlaceCountry': {
            handler (newVal, oldVal) {
                if (newVal) {
                    this.dadStateList = this.getStateListByCountryId(newVal)
                }
                if (oldVal === null) return
                if (newVal != lookupService.CountryEnum.Other) this.applicant.fatherBirthPlaceCountryOther = null
                if (!this.momStateList.find(x => x.id == this.applicant.fatherBirthPlaceState)) {
                    this.applicant.fatherBirthPlaceState = null
                }
            }
        },
        'applicant.fatherBirthPlaceState': {
            handler (newVal, oldVal) {
                if (oldVal === null) return
                if (newVal != lookupService.StateEnum.Other) this.applicant.fatherBirthPlaceStateOther = null
            }
        },
        'applicant.raceList': {
            handler (newVal, oldVal) {
                if (oldVal === null) return
                if (!(newVal || []).includes(lookupService.RaceEnum.Other)) {
                    this.applicant.raceOther = null
                }
                if (!(newVal || []).includes(lookupService.RaceEnum.OtherAsian)) {
                    this.applicant.raceOtherAsian = null
                }
                if (!(newVal || []).includes(lookupService.RaceEnum.OtherPacificIslander)) {
                    this.applicant.raceOtherPacificIslander = null
                }
                if (!(newVal || []).includes(lookupService.RaceEnum.AmericanIndianOrAfricanAmerican)) {
                    this.applicant.raceOtherA = null
                }
            }
        }
    }
}
</script>

<style module>
h4 {
    font-weight: 700 !important;
}
</style>
